export var ForwarderType;
(function (ForwarderType) {
    ForwarderType["TAIJI"] = "taiji";
    ForwarderType["C2C"] = "c2c";
    ForwarderType["QX_PAY"] = "qx_pay";
    ForwarderType["DBY"] = "dby";
    ForwarderType["SFA"] = "sfa";
    ForwarderType["WALL_STREET"] = "wallstreet";
    ForwarderType["HF_PAY"] = "hf_pay";
    ForwarderType["WMH"] = "wmh";
    ForwarderType["JF_PAY"] = "jf_pay";
    ForwarderType["LTEZP"] = "ltezp";
    ForwarderType["TA"] = "ta";
    ForwarderType["SUNFAR"] = "the_pay";
    ForwarderType["SMILE_PAY"] = "smile_pay";
    ForwarderType["TRC"] = "trc";
    ForwarderType["KH_PAY"] = "kh_pay";
    ForwarderType["SEA_PAY"] = "sea_pay";
    ForwarderType["FT_PAY"] = "zi_nan";
    ForwarderType["LHX_PAY"] = "lhx_pay";
    ForwarderType["ET_PAY"] = "et_pay";
    ForwarderType["LGV_PAY"] = "lgv_pay";
    ForwarderType["YY_PAY"] = "yy_pay";
    ForwarderType["FLY_PAY"] = "fly_pay";
    ForwarderType["JD_PAY"] = "jd_pay";
    ForwarderType["HX_PAY"] = "hxpay";
    ForwarderType["GOUBAO"] = "goubao";
    ForwarderType["TOPAY"] = "topay";
    ForwarderType["EBPAY"] = "ebpay";
    ForwarderType["SF"] = "sf";
    ForwarderType["GOLDEN"] = "golden";
    ForwarderType["GOLDEN_WECHAT"] = "golden_wechat";
    ForwarderType["GOLDEN_ALIPAY"] = "golden_alipay";
    ForwarderType["CGPAY"] = "cgpay";
})(ForwarderType || (ForwarderType = {}));
//# sourceMappingURL=ForwarderType.js.map